export default __webpack_public_path__ + "static/media/plus.caae85cd.svg";